module.exports = __webpack_public_path__ + "media/outdoor.3ad1ce24.jpg";